import { GiSemiClosedEye } from "react-icons/gi";
import ForgeLogo from "./logo";

function CircularBadge({ text = "FIRE MAY FORGE THE BLADE · BUT ONLY DISCIPLINE KEEPS ITS EDGE ·", colors = "#fff", logoSize = 70, isForge = true, icon: CustomIcon = null }) {
  // Base values
  const baseRadius = 52;
  const baseChars = 50;

  // Increase radius based on text length
  const radius = Math.max(baseRadius, baseRadius + (text.length - baseChars) * 0.7);

  const size = radius * 2 + 56;
  const center = size / 2;

  const circlePath = `
    M ${center},${center}
    m -${radius},0
    a ${radius},${radius} 0 1,1 ${radius * 2},0
    a ${radius},${radius} 0 1,1 -${radius * 2},0
  `;

  return (
    <div
      className="wws__badge"
      role="img"
      aria-label={text}
      style={{
        width: size,
        height: size,
      }}
    >
      <svg className="wws__badge-ring rotateC" viewBox={`0 0 ${size} ${size}`}>
        <defs>
          <path id="badgeCircle" d={circlePath} />
        </defs>

        <circle cx={center} cy={center} r={radius + 18} fill="none" stroke={colors} strokeWidth={2} />

        <text
          className="wws__badge-text"
          style={{
            fill: colors,
            fontWeight: 700,
            letterSpacing: "3px",
          }}
        >
          <textPath href="#badgeCircle" startOffset="0%" textLength={Math.PI * radius * 2} lengthAdjust="spacing">
            {text}
          </textPath>
        </text>

        <circle cx={center} cy={center} r={radius - 5} fill="none" stroke={colors} strokeWidth={1} />
      </svg>

      <div
        className="wws__badge-logo position-absolute"
        style={{
          width: logoSize,
          height: logoSize,
        }}
      >
        {CustomIcon ? <CustomIcon color={colors} size={logoSize} /> : isForge ? <ForgeLogo fill={colors} width={logoSize} height={logoSize} /> : <GiSemiClosedEye color={colors} size={logoSize} />}
      </div>
    </div>
  );
}

export default CircularBadge;
